var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18.4167C0 10.5926 6.34263 4.25 14.1667 4.25H53.8333C61.6574 4.25 68 10.5926 68 18.4167V38.25C68 46.074 61.6574 52.4167 53.8333 52.4167H14.1667C6.34263 52.4167 0 46.074 0 38.25V18.4167Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3886 47.452C22.5583 45.1879 25.501 43.916 28.5694 43.916H45.0972C48.1656 43.916 51.1084 45.1879 53.278 47.452C55.4477 49.716 56.6667 52.7867 56.6667 55.9885V60.3001C56.6667 62.2051 55.1867 63.7494 53.3611 63.7494C52.0089 63.7494 21.6578 63.7494 20.3056 63.7494C18.4799 63.7494 17 62.2051 17 60.3001V55.9885C17 52.7867 18.2189 49.716 20.3886 47.452Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 29.7493C25.5 23.4901 30.5741 18.416 36.8333 18.416C43.0926 18.416 48.1667 23.4901 48.1667 29.7493C48.1667 36.0086 43.0926 41.0827 36.8333 41.0827C30.5741 41.0827 25.5 36.0086 25.5 29.7493Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9b560fe899a12c2e49719a4b753b4c1f.svg";
export { ForwardRef as ReactComponent };